import { useContext, useEffect, useState } from "react";
import {
  createUserRole,
  getBaseRolesByTenant,
  getUserRoleByUser,
} from "../services/console/userrole";
import { AppContext } from "../context";

type UseType = "DATA" | "ACTIONS" | "ROLES" | "DATABYTENANT";

type ActionType = "CREATE" | "UPDATE" | "DELETE";

const handleActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createUserRole,
        fnMsg: t("Users.userRoleApiCreateLabel"),
      };
      case "UPDATE":
        return {
          actionFn: () => ({}),
          fnMsg: t("Users.userRoleApiUpdateLabel"),
        };
    case "DELETE":
      return {
        actionFn: () => ({}),
        fnMsg: t("Users.userRoleApiDeleteLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useUserRole = (type: UseType, tenantIdByRolesConsult?: string) => {
  const { 
    t,
    toast, 
    appState: { tenantId, selectedTenantId, isMainTenant, selectedUser },
    setAppState,
  } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [dataRoles, setDataRoles] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);
  const user = selectedUser?.id || "0"

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const userRoleAction = async (action: ActionType, data: any, userInfo?: any) => {
    const { actionFn, fnMsg } = handleActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg.replace('{name}', `${userInfo?.firstName} ${userInfo?.lastName}`)}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA" || type === "DATABYTENANT") {
      (async function () {
        await Promise.resolve(getBaseRolesByTenant(
          type === "DATABYTENANT"
            ? tenantIdByRolesConsult
            : (selectedTenantId! || tenantId)
          , isMainTenant ? "BASE" : ""))
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            setData([]);
          });
      })();
    }
  }, [toast, reload, type, isMainTenant]);
  
  useEffect(() => {
    if (type === "ROLES") {
      (async function () {
        await Promise.resolve(getUserRoleByUser(user))
          .then((response) => {
            setDataRoles(response?.data);
          })
          .catch((error) => {
            setDataRoles([]);
          });
      })();
    }
  }, [user, toast, reload, type]);

  return {
    data,
    userRoleAction,
    reloadFn,
    dataRoles,
  };
};
